import React from 'react';
import { Badge } from '../ui/badge';
import { getStatusClass } from '../../lib/utils';
import { ExternalLink } from 'lucide-react';

export default function AdminStandards({ standards }) {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-semibold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Standards
        </h2>
        <p className="text-sm text-zinc-500 mt-1">Standards are defined by the authority site and cannot be edited.</p>
      </div>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Version</th>
              <th>Status</th>
              <th>Authority URL</th>
            </tr>
          </thead>
          <tbody>
            {standards.map(std => (
              <tr key={std.id}>
                <td className="cert-id">{std.id}</td>
                <td>{std.title}</td>
                <td>{std.version}</td>
                <td>
                  <Badge variant="outline" className={`rounded-none ${getStatusClass(std.status)}`}>
                    {std.status}
                  </Badge>
                </td>
                <td>
                  <a href={std.authority_url} target="_blank" rel="noopener noreferrer" className="text-zinc-600 hover:text-zinc-900 inline-flex items-center gap-1">
                    View <ExternalLink className="w-3 h-3" />
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
